<template>
  <div class="record" :class="isScroll?'':'isBackground'">
    <Header :title="title" :right-content="rightContent" />
    <div id="content" :class="pageType == 'app'?'isApp':''">
      <div class="layout">
        <div class="recordCon">
          <div v-if="pageType != 'app'" class="itemNav">
            <ul>
              <li v-for="(item, index) in recordNav" :key="index" :class="{ checked: tabIndex == index }" @click="tabClick(index)">
                <span>{{
                  item.name }}</span>
                <p />
              </li>
            </ul>
          </div>
          <div v-if="mt5Enabled && !isTransfer()" class="select-account-container">
            <SelectAccount @onOpen="onOpenSelectAccount" @onClose="onCloseSelectAccount" @onConfirmAccount="onConfirmAccount" />
          </div>
          <div class="time">
            <div class="item" @click="selectTime">
              <p>{{ new Date(timeData).format("Y年MM月") }}</p><img src="@/assets/images/template/toolbar_calendar.png">
            </div>
            <div v-if="!isTransfer()" class="item baseline">
              <p>余额</p><span><em>$</em>{{ totalBalance }}</span>
            </div>
          </div>
          <div v-if="mt5Enabled && isTransfer()" class="time second-row">
            <div class="item second-row">
              <div><p>CFD余额</p><span><em>$</em>{{ balance.GTS2 }}</span></div>
              <div><p>MT5余额</p><span><em>$</em>{{ balance.MT5 }}</span></div>
            </div>
          </div>
          <div class="itemRecord">
            <div class="itemTime"><p>{{ new Date(timeData).format("MM/Y") }}</p></div>
            <div class="money">
              <ul v-if="!isTransfer()">
                <li>
                  <p>收入</p><span><em>$</em>{{ parseFloat(income).toFixed(2) }}</span>
                </li>
                <li>
                  <p>支出</p><span><em>$</em>{{ parseFloat(expenditure).toFixed(2) }}</span>
                </li>
              </ul>
              <ul v-if="mt5Enabled && isTransfer()">
                <li>
                  <p>CFD平台转账总额</p><span><em>$</em>{{ !isNaN(totalTransfer.GTS2) ? parseFloat(totalTransfer.GTS2).toFixed(2) : '0.00' }}</span>
                </li>
                <li>
                  <p>MT5平台转账总额</p><span><em>$</em>{{ !isNaN(totalTransfer.MT5) ? parseFloat(totalTransfer.MT5).toFixed(2) : '0.00' }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="refresh"><span>{{ new Date(timeData).format("MM月dd日") }}</span><img
            src="@/assets/images/template/toolbar_refresh.png"
            @click="flashTime"
          ></div>
        </div>
        <div class="recordList" :class="{'withSelectAccount': mt5Enabled, 'transfer': mt5Enabled && isTransfer(), 'app': mt5Enabled && pageType == 'app'}">
          <ul v-if="recordList.length > 0">
            <li v-for="(item, index) in recordList " :key="item.pno" @click="goRecordDetail(item, tabIndex)">
              <div class="num">
                <p>{{ item.pno }} <button
                  v-if="((tabIndex == 0) || (typeName == 'deposit' && typeName != ''))"
                  :disabled="item.attachments.length > 0"
                  class="uploadBtn"
                  @click.stop="goUploadDocuments(item, tabIndex)"
                >{{ item.attachments.length > 0 ?
                  '已上传' : '上传凭证' }}</button>
                  <!-- <button v-if="(tabIndex == 1 || typeName == 'withdraw' && typeName != '') && item.proposalStatus == 1 && !withdrawList[index].isConfirmed && withdrawList[index].matchList.filter(match => !['RECEIVED', 'NOT_RECEIVED'].includes(match.confirmStatus)).length > 0" class="confirmBtn">请确认</button> -->
                </p>
                <span v-if="((tabIndex == 0) || (typeName == 'deposit' && typeName != ''))"><em>$</em>{{ item.payAmount
                }}</span>
                <span v-if="((tabIndex == 1) || (typeName == 'withdraw' && typeName != ''))"><em>$</em>{{ item.transAmount
                }}</span>
                <span v-if="mt5Enabled && isTransfer()"><em>$</em>{{ item.amount
                }}</span>
              </div>
              <div v-if="mt5Enabled && isTransfer()" class="platform">
                <p>
                  转出平台: {{ item.fromPlatform }}
                </p>
                <p>
                  转入平台: {{ item.toPlatform }}
                </p>
              </div>
              <div class="name">
                <div class="item">
                  <p v-if="((tabIndex==0)||(typeName=='deposit'&&typeName!=''))">{{ item.gatewayCode }}</p>
                  <p v-if="((tabIndex==1)||(typeName=='withdraw'&&typeName!=''))">{{ item.withdrewBankName }}</p>
                  <p>{{ item.createDate }}</p>
                </div>
                <div v-if="!isTransfer()" class="item">
                  <p :class="item.proposalStatus == 1 ? '' : item.proposalStatus == 2 ? 'suc' : 'fail'">
                    {{ item.proposalStatus == 1 ? "处理中" : item.proposalStatus == 2 ? "成功" : item.proposalStatus == -2 ?
                      '逾期' : item.proposalStatus == -3 ?"失败":"已取消" }}</p>
                </div>
              </div>
            </li>
          </ul>
          <noData v-else />
          <div
            v-if="((tabIndex == 0) || (typeName == 'deposit' && typeName != '')) && this.depositList.length >= 10 && this.totalPageDeposit > 1"
            class="more"
            @click="clickMore"
          ><span>加载更多</span></div>
          <div
            v-if="((tabIndex == 1) || (typeName == 'withdraw' && typeName != '')) && this.withdrawList.length >= 10 && this.totalPageWithdraw > 1"
            class="more"
            @click="clickMore"
          ><span>加载更多</span></div>
        </div>
      </div>
    </div>
    <Time v-if="isTime" :show="isTime" @change="change" @cancel="cancel" />
    <ToHome :show="showToHome" />
  </div>
</template>

<script>
require('@/assets/css/record.css')
import Header from '@/view/module/Header.vue'
import ToHome from '@/view/module/ToHome.vue'
import Time from '@/view/record/Time.vue'
import noData from '@/view/module/noData.vue'
import api from '@/plugins/api'
import '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
import { isMT5Enabled } from '@/utils/helper'
import SelectAccount from '@/view/module/SelectAccount.vue'

export default {
  name: 'Record',
  components: { Header, Time, ToHome, noData, SelectAccount },
  computed: {
    ...mapState(['gts2CustomerId', 'platform', 'tabIndex', 'timeData', 'keepAlive', 'pageType'])
  },
  data() {
    return {
      title: '存取款记录',
      rightContent: 'isNo',
      isScroll: '',
      recordNav: [{ name: '存款记录', id: '0' }, { name: '取款记录', id: '1' }],
      isTime: false,
      recordList: '', // 记录列表
      depositList: '', // 存款记录列表
      withdrawList: '', // 存款记录列表
      transferList: '',
      pno: '', // 订单号
      payType: '', // 支付方式
      createTime: '', // 创建时间
      amount: 0, // 金额
      proposalStatus: '', // 状态
      income: 0,
      expenditure: 0,
      totalTransfer: {
        GTS2: 0,
        MT5: 0
      },
      totalPage: '', // 总页数
      totalPageDeposit: '', // 存款总页数
      totalPageWithdraw: '', // 存款总页数
      totalPageTransfer: '',
      num: 10,
      totalBalance: 0, // 余额
      balance: {
        'GTS2': 0,
        'MT5': 0
      },
      typeName: this.$route.query.typeName || '',
      mt5Enabled: isMT5Enabled(),
      showToHome: true
    }
  },
  mounted() {
    this.initMounted()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
    if (this.keepAlive == 0) {
      this.initData()
      this.AccTradeInfo()
    }
  },
  methods: {
    initMounted() {
      if (!this.timeData) this.$store.dispatch('setTimeData', new Date())
      if (this.pageType == 'app') this.$store.dispatch('setTabIndex', -1)
    
      this.removeFixed()
      this.$bus.$emit('loading', true)
      window.scrollTo(0, 0)
      this.hasScrollbar()
      this.initData()
      this.AccTradeInfo()
      if (this.pageType == 'app') {
        this.$store.dispatch('setTabIndex', -1)
      }
    },
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    hasScrollbar() {
      if (document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    tabClick(index) {
      this.$store.dispatch('setTabIndex', index)
      if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'deposit')) {
        this.recordList = this.depositList
        this.totalPage = this.totalPageDeposit
      }
      if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'withdraw')) {
        this.recordList = this.withdrawList
        this.totalPage = this.totalPageWithdraw
      }
      if (this.mt5Enabled && this.isTransfer()) {
        this.recordList = this.transferList
        this.totalPage = this.totalPageTransfer
      }
    },
    change(data) {
      const dataString = data.toString()
      this.$store.dispatch('setTimeData', dataString.replace(/\//gi, '-'))
      this.initData()
    },
    cancel(show) {
      this.isTime = show
    },
    selectTime() {
      this.isTime = true
    },
    flashTime() {
      this.$bus.$emit('loading', false)
      this.initData()
      this.AccTradeInfo()
    },
    AccTradeInfo() {
      api.getAccTradeInfo(this.gts2CustomerId).then(res => {
        if (res.data.code == 200) {
          this.totalBalance = res.data.data.accountSummary.totalMoney
          if (this.mt5Enabled && res.data.data.accTradeInfoList.length > 1) {
            if (this.recordNav.length < 3) {
              this.title = '存取款及转账记录'
              this.recordNav = [
                ...this.recordNav,
                { name: '转账记录', id: '2' }
              ]
            }

            this.balance.GTS2 = res.data.data.accTradeInfoList.find(acc => acc.platform == 'GTS2').balance
            this.balance.MT5 = res.data.data.accTradeInfoList.find(acc => acc.platform == 'MT5').balance
            this.initData()
          }
        }
      })
    },
    initData() {
      const data = {
        index: 1,
        pageSize: 10,
        gts2CustomerId: this.gts2CustomerId,
        // platform: this.platform,
        month: new Date(this.timeData).format('Y-MM')
      }
      this.depositProposalList(data)
      this.withdrawProposalList(data)
      if (this.mt5Enabled && this.recordNav.find(nav => nav.id == '2')) {
        this.transferProposalList(data)
      }
    },
    depositProposalList(data) {
      api.getDepositProposalList(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.depositList = res.data.data.depositProposalList
            this.totalPageDeposit = res.data.data.totalPage
            if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'deposit')) {
              this.recordList = this.depositList
              this.totalPage = this.totalPageDeposit
            }
            this.income = res.data.data.totalIncome
          }
        }
      })
    },
    withdrawProposalList(data) {
      api.getWithdrawProposalList(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.withdrawList = res.data.data.withdrawProposalList
            this.totalPageWithdraw = res.data.data.totalPage
            if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'withdraw')) {
              this.recordList = this.withdrawList
              this.totalPage = this.totalPageWithdraw
            }
            this.expenditure = res.data.data.totalExpenditure
          }
        }
      })
    },
    transferProposalList(data) {
      api.getTransferProposalList(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.transferList = res.data.data.transferProposalList
            this.totalPageTransfer = res.data.data.totalPage
            if (this.isTransfer()) {
              this.recordList = this.transferList
              this.totalPage = this.totalPageTransfer
            }
            this.totalTransfer = res.data.data.totalTransfer
          }
        }
      })
    },
    goRecordDetail(data, obj) {
      let payAmount, payType, exchangeRate, transAmount
      if (((obj != -1 && obj == 0) || (this.typeName != '' && this.typeName == 'deposit'))) {
        payAmount = data.payAmount
        payType = data.gatewayCode
      }
      if (((obj != -1 && obj == 1) || (this.typeName != '' && this.typeName == 'withdraw'))) {
        transAmount = data.transAmount
        payAmount = data.payAmount
        payType = data.accountNo
        exchangeRate = data.exchangeRate
      }

      if (this.mt5Enabled && this.isTransfer()) {
        payAmount = data.amount
        // payType = data.accountNo
      }
      const query = {
        pno: data.pno,
        remark: data.remark,
        transAmount: transAmount,
        payAmount: payAmount,
        payType: payType,
        exchangeRate: exchangeRate,
        createDate: data.createDate,
        pendingExpireDate: data.pendingExpireDate,
        updateDate: data.updateDate,
        proposalStatus: data.proposalStatus,
        dueBank: data.dueBank,
        recordType: this.typeName ? this.typeName : obj,
        paymentType: data.paymentType,
        matchList: data.matchList ? JSON.stringify(data.matchList) : '',
        fee: data.fee,
        fromPlatform: data.fromPlatform,
        toPlatform: data.toPlatform
      }
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/recordDetail', query: query })
    },
    goUploadDocuments(data) {
      this.$router.push({ path: '/home/uploadDocuments', query: { pno: data.pno, from: 'record' }})
    },
    clickMore() {
      this.num += 10
      const data = {
        index: 1,
        pageSize: this.num,
        gts2CustomerId: this.gts2CustomerId,
        platform: this.platform,
        month: new Date(this.timeData).format('Y-MM')
      }
      if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'deposit')) {
        this.depositProposalList(data)
      }
      if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'withdraw')) {
        this.withdrawProposalList(data)
      }
      if (this.mt5Enabled && this.isTransfer()) {
        this.transferProposalList(data)
      }
    },
    onConfirmAccount() {
      this.initMounted()
    },
    onOpenSelectAccount() {
      this.showToHome = false
    },
    onCloseSelectAccount() {
      this.showToHome = true
    },
    isTransfer() {
      return this.tabIndex == 2 || // mobile
      this.typeName == 'transfer' && this.typeName != '' // app
    }
  }
}
</script>
